import { Button } from "common/buttons";
import { urlByType } from "domain/common/url-utils";
import React from "react";
import { useNavigate } from "react-router";
import styles from "./FolderNavigation.module.css";

interface FolderNavigationElement {
  title: string;
  id: string;
  __typename:
    | "Folder"
    | "Kurssloeyfe"
    | "Article"
    | "MultipleChoice"
    | "StudyProgramme"
    | "ExamSyllabus";
}

interface Props {
  currentElementId: string;
  folderElements: FolderNavigationElement[];
  showPrevious?: boolean;
  nextButtonText?: string;
  intent?: "primary" | "secondary";
}

export const FolderNavigation: React.FC<React.PropsWithChildren<Props>> = ({
  currentElementId,
  folderElements,
  nextButtonText = "Gå videre",
  showPrevious = true,
}) => {
  const navigate = useNavigate();

  const currentElementIndex = folderElements.findIndex(
    (e) => e.id === currentElementId,
  );

  const previousElement = folderElements[currentElementIndex - 1];
  const nextElement =
    folderElements[currentElementIndex + 1] ===
    folderElements[currentElementIndex]
      ? folderElements[currentElementIndex + 2]
      : folderElements[currentElementIndex + 1];

  const handleNavigation = (link: FolderNavigationElement) => {
    const url = urlByType(link.__typename, link.id, false);
    navigate(url);
  };

  return (
    <nav className={styles.container}>
      {previousElement && showPrevious && (
        <Button
          kind="secondary"
          onClick={() => {
            handleNavigation(previousElement);
          }}
        >
          Forrige element
        </Button>
      )}
      {nextElement && (
        <Button
          kind="primary"
          onClick={() => {
            handleNavigation(nextElement);
          }}
        >
          {nextButtonText}: {nextElement.title}
        </Button>
      )}
    </nav>
  );
};
